import { Receptor } from "./Receptor";

export function esRutGenerico(rut: string): boolean {
	return ["555555555", "666666666"].includes(String(rut || "").replace(/[.\s-]/g, ""));
}

export function cambiaronDatosReceptor(original: Partial<Receptor>, actual: Partial<Receptor>): boolean {
	const campos: (keyof Receptor)[] = ["razonSocial", "nombreFantasia", "giro", "dirPart", "dirFact", "comuna", "ciudad", "correoPar", "correoFact"];
	return campos.some(campo => String(original?.[campo] ?? "").trim() !== String(actual?.[campo] ?? "").trim());
}
